import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { copyTextToClipboard } from "@/utils/clipboard";
import { successToast } from "@/utils/toasts";

export function BankCard({ ownerName, bankName, cardNumber }) {
    return (
        <Grid
            container
            xs={12}
            sx={{
                cursor: "pointer",
            }}
            onClick={() =>
                copyTextToClipboard(
                    cardNumber?.replace(/\s/g, "") ?? "",
                    () => {
                        successToast(`شماره کارت ${bankName} با موفقیت کپی شد`);
                    }
                )
            }
        >
            <Grid
                item
                xs={12}
                display="flex"
                alignItems="start"
                sx={{ flexDirection: { xs: "column", sm: "row" } }}
            >
                <Grid container>
                    <Grid item>
                        <Typography
                            dir="ltr"
                            sx={{
                                letterSpacing: "1px",
                                fontWeight: "bold",
                                fontSize: "1rem",
                            }}
                        >
                            {cardNumber}
                        </Typography>
                    </Grid>
                    <Grid item sx={{ marginLeft: "8px" }}>
                        <ContentCopyIcon sx={{ fontSize: "1.35rem" }} />
                    </Grid>
                </Grid>
            </Grid>

            <Grid
                item
                xs={12}
                display="flex"
                alignItems={"start"}
                sx={{
                    flexDirection: { xs: "column", sm: "row" },
                }}
            >
                <Typography sx={{ fontSize: "0.9rem" }}>
                    به نام {ownerName} - {bankName}
                </Typography>
            </Grid>
        </Grid>
    );
}
